
import Vue from 'vue'

import BaseImage from '@/components/BaseImage.vue'

import { SVG_PLACEHOLDER_IMAGES } from '@/constants'
import {
  MagazineCard
} from '@/pages/magazine/types'
import { MAGAZINE_TYPE_BASE_URLS } from '../consts'

const MAX_DISPLAY_CHARACTER = 35

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    magazine: {
      type: Object as () => MagazineCard,
      required: true
    },
    baseUrl: {
      type: String,
      required: true
    },
    queries: {
      type: Object as () => {[key: string]: string} | undefined,
      default: undefined,
      required: false
    }
  },
  computed: {
     placeholder(): string {
      return this.baseUrl === MAGAZINE_TYPE_BASE_URLS.CATEGORY
        ? SVG_PLACEHOLDER_IMAGES.CATEGORY_HERO_IMAGE : SVG_PLACEHOLDER_IMAGES.MAGAZINE_CARD
    },
    path(): string {
      const urlQueries = this.queries ? `?${this.buildQueries(this.queries)}` : ''
      return `${this.baseUrl}/${this.magazine.path}${urlQueries}`
    },
    shortTitle(): string {
      return this.magazine.h1.length > MAX_DISPLAY_CHARACTER
        ? this.magazine.h1.substr(0, MAX_DISPLAY_CHARACTER) + '...'
        : this.magazine.h1
    }
  },
  methods: {
    buildQueries(queries: { [kay: string]: string}) {
      return Object.keys(queries).map(key => {
        return `${key}=${queries[key]}`
      }).join('&')
    }
  }
})
